import React, { useContext, useEffect, useState } from "react";
import StudiesPage from "./StudiesPage";
import { useParams } from "react-router";
import Footer from "../Footer";
import Navbar from "../Navbar";
import { ResizableX, ResizableY } from "../Modules/ResizeTable/Layouts";
import ResizerXManager from "../../Components/ResizerXManager/ResizerXManager";
import { ResizablexContext } from "../Modules/ResizeTable/ResizeTable";
import StudySidebar from "./StudySidebar";

const Studies = ({ tableRef, onMouseDown }) => {
  const resizableX = useContext(ResizablexContext);
  const [collapseSidebar, setCollpaseSidebar] = useState(false);
  const { studyId } = useParams();
  const [studyTabs, setStudyTabs] = useState([]);

  useEffect(() => {
    resizableX();
  });

  const handleAddNewTab = (
    studyTabName,
    icon,
    studyTabId,
    idObject,
    breadcrumb
  ) => {
    let newTab = {
      studyTabId: studyTabId,
      studyTabName: studyTabName,
      icon: icon,
      openDT: new Date(),
      status: "active",
    };
    if (idObject) {
      newTab.idObject = idObject;
    }
    if (breadcrumb?.length > 0) {
      newTab.breadcrumb = breadcrumb || [];
    }
    const updatedTabs = studyTabs?.map((studyTab) => ({
      ...studyTab,
      status: "inactive",
    }));
    const existTab = studyTabs?.some(
      (studyTab) => studyTab.studyTabId === studyTabId
    );
    if (existTab) {
      updatedTabs.forEach((element) => {
        if (element.studyTabId === studyTabId) {
          element.status = "active";
          element.studyTabName = studyTabName;
          if (idObject) {
            element.idObject = idObject;
          }
          if (breadcrumb?.length > 0) {
            element.breadcrumb = breadcrumb || [];
          }
        }
      });
      setStudyTabs(updatedTabs || []);
    } else {
      setStudyTabs([...updatedTabs, newTab] || []);
    }
  };

  const checkActiveTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId === studyTabId && item.status === "active"
    );
  };

  const checkHomeActiveTab = () => {
    return studyTabs?.some((item) => item.status === "active");
  };
  
  const checkActiveTabData = (tabId) => {
    return studyTabs?.find((item) => item.studyTabId === tabId);
  };

  const checkDynamicActiveTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId.includes(studyTabId) && item.status === "active"
    );
  };

  const checkActiveDynamicTabData = (studyTabId) => {
    return studyTabs?.find(
      (item) => item.studyTabId?.includes(studyTabId) && item.status === "active"
    );
  };

  const activeStudyTab = studyTabs?.some((item) => item.status === "active");

  const [objectId, setObjectId] = useState(null);
  const [breadcrumbData, setBreadcrumbData] = useState([]);

  useEffect(() => {
    let data = studyTabs?.find((item) => item.status === "active");
    setObjectId(data?.idObject);
    setBreadcrumbData(data?.breadcrumb || []);
  }, [studyTabs]);

  useEffect(() => {
    const savedStudyTabs = JSON.parse(localStorage.getItem("studyTabs")) || [];
    if (savedStudyTabs) {
      setStudyTabs(savedStudyTabs || []);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("studyTabs", JSON.stringify(studyTabs));
  }, [studyTabs]);

  return (
    <>
      <Navbar />
      <ResizableX>
        <div style={{ width: collapseSidebar ? 45 : 300 }}>
          <section className="middle-content">
            <StudySidebar
              studyId={studyId}
              handleAddNewTab={handleAddNewTab}
              checkActiveTab={checkActiveTab}
              checkActiveDynamicTabData={checkActiveDynamicTabData}
              collapseSidebar={collapseSidebar}
            />
          </section>
        </div>
        <ResizerXManager collapseSidebar={collapseSidebar} />
        <ResizableY>
          <StudiesPage
            collapseSidebar={collapseSidebar}
            setCollpaseSidebar={setCollpaseSidebar}
            tableRef={tableRef} 
            onMouseDown={onMouseDown}
            studyTabs={studyTabs}
            setStudyTabs={setStudyTabs}
            checkActiveTabData={checkActiveTabData}
            activeStudyTab={activeStudyTab}
            checkActiveTab={checkActiveTab}
            handleAddNewTab={handleAddNewTab}
            checkDynamicActiveTab={checkDynamicActiveTab}
            checkActiveDynamicTabData={checkActiveDynamicTabData}
            checkHomeActiveTab={checkHomeActiveTab}
            objectId={objectId}
            breadcrumbData={breadcrumbData}
          />
        </ResizableY>
      </ResizableX>
      <Footer />
    </>
  );
};

export default Studies;
